<template>
    <div>
        <div class="event-list-item__core-info d-flex" :class="!event.pastevent ? '' : 'text-disabled'">
            <svg-icon-clock :class="clockClass"></svg-icon-clock>
            <div class="d-flex flex-row align-items-start justify-content-between" style="padding-left: 10px; width: 100%">
                <div class="d-flex flex-column">
                    <div>
                        <strong class="event-list-item__date">{{ agenda.agenda_date | format_date }}</strong> ab {{ agenda.agenda_begin }} Uhr
                    </div>
                    <div>
                        <!-- <span class="event-list-item__title" v-if="!detailView">{{ agenda.agenda_title }}</span> -->
                        <span class="event-list-item__title">{{ agenda.agenda_title }} <span v-if="agenda.agenda_entryfee">(Eintritt {{ agenda.agenda_entryfee }}&euro;)</span></span>
                        <b-badge pill variant="danger" v-if="!event.pastevent && agenda.agenda_rsvp_date">Rückmeldung erbeten bis {{ agenda.agenda_rsvp_date | format_date }}</b-badge>
                    </div>
                </div>
                <div class="d-flex flex-column text-center">
                    <svg-icon-social ></svg-icon-social>
                    {{ agenda.agenda_registered_attendee_count }}
                </div>
            </div>
        </div>
        <template v-if="(event.nextevent && !event.pastevent) || detailView">
            <div class="event-list-item__description">
                <!-- <h6 v-if="detailView" class="mb-1 event-list-item__description-title">{{ agenda.agenda_title }}</h6> -->
                <template v-if="!hideAgendaIntro"><span v-html="nl2br(agenda.agenda_intro)"></span></template></div>
        </template>
    </div>
</template>

<script>
// import moment from 'moment';
import SvgIconClock from '@/components/svg-icon/Clock.vue';
import SvgIconSocial from '@/components/svg-icon/Social.vue';
import { mapGetters } from "vuex";
export default {
    name: 'event-core-vue',
    components: {
        'svg-icon-clock': SvgIconClock,
        'svg-icon-social': SvgIconSocial
    },
    computed: { 
        ...mapGetters('auth', ['isActivity']),
        clockClass() {
            if (this.agenda.agenda_rsvp_date && !this.event.pastevent) {
                return 'text-danger';
            } else {
                if (this.agenda.user_is_attendee) {
                    if (this.agenda.user_is_not_available) {
                        return 'text-danger';
                    } else {
                        return 'text-success';
                    }
                    
                } else {
                    return 'text-disabled'
                }
                
            }
        }
    },
    // filters: {
    //     format_date: (date) => {
    //         return moment(date).format('DD.MM.YYYY');
    //     }
    // },
    props: {
        event: {
            type: Object
        },
        agenda: {
            type: Object
        },
        detailView: {
            type: Boolean
        },
        hideAgendaIntro: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        nl2br(string) {
            return string.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
.event-list-item {

    &__core-info,
    &__description,
    &__description-title {
        font-size: 14px;
        line-height: 1.3;
        color: $primary;
    }

    &__description,
    &__description-title {
        color: $black;
    }

    &__date {
        font-size: 16px;
    }

    &__title {
        display: block;
        color: $black;

        .text-disabled & {
            color: $gray-25;
        }
    }
}
</style>